<template>
  <a-sub-menu :key="String(menuInfo.id)">
    <template v-slot:title>
      <span>
        <img
          :src="menuInfo.menuIcon"
          alt=""
          v-if="menuInfo.menuIcon"
          class="menuIcon"
        />
        <!-- <span>{{ menuInfo.menuName }}</span> -->
        <a-tooltip
          placement="top"
          overlayClassName="Ktool fs12"
          :color="overColor"
          :title="
            isEnglish && menuInfo.menuNameEn
              ? menuInfo.menuNameEn
              : menuInfo.menuName
          "
        >
          <span :key="isEnglish">{{
            isEnglish && menuInfo.menuNameEn
              ? menuInfo.menuNameEn
              : menuInfo.menuName
          }}</span>
        </a-tooltip>
      </span>
    </template>
    <template v-for="item in menuInfo.childrenList" :key="String(item.id)">
      <sidebar-item
        class="sidebar-item"
        :menu-info="item"
        v-if="item.menuType != 2 && item.childrenList"
        :key="String(item.id)"
      />
      <a-menu-item
        :key="item.menuPath"
        :id="String(item.id)"
        class="sidebar-item"
        v-else
      >
        <!-- 图标 -->
        <img
          :src="item.menuIcon"
          alt=""
          v-if="item.menuIcon"
          class="menuIcon"
        />
        <a-tooltip
          overlayClassName="Ktool fs12"
          placement="right"
          :color="overColor"
          :title="
            isEnglish && item.menuNameEn ? item.menuNameEn : item.menuName
          "
        >
          <span :key="isEnglish">{{
            isEnglish && item.menuNameEn ? item.menuNameEn : item.menuName
          }}</span>
        </a-tooltip>
        <div class="favorite-icon" @click="handleFavorite($event, item)">
          <a-tooltip
            title="收藏"
            placement="left"
            :color="overColor"
            overlayClassName="fs12"
            v-if="item.favorite === 0"
          >
            <StarOutlined />
          </a-tooltip>
          <a-tooltip
            title="取消收藏"
            placement="left"
            :color="overColor"
            overlayClassName="fs12"
            v-else-if="item.favorite === 1"
          >
            <StarFilled />
          </a-tooltip>
        </div>
      </a-menu-item>
    </template>
  </a-sub-menu>
</template>

<script>
import { ref, getCurrentInstance, reactive, toRefs } from 'vue'
import { message } from 'ant-design-vue'
import { StarOutlined, StarFilled } from '@ant-design/icons-vue'
// import { cupshe_GA } from 'cupshe-ga'
import { useStore } from 'vuex'

import { add_favorite_menu, remove_favorite_menu } from 'server/modules/351.js'
import store from '../../store/index'

export default {
  name: 'SildebarItem',
  components: {
    StarOutlined,
    StarFilled
  },
  props: {
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const {
      proxy: { i18n }
    } = getCurrentInstance()
    const isEnglish = ref(i18n.global.locale !== 'zh-CN')
    const store = useStore()
    const state = reactive({
      // 监听菜单 触发埋点
      gaApi: item => {
        const { id, menuName } = item
        const { userName, userId } = store.state.user.userInfo
        // cupshe_GA(
        //   'click',
        //   {
        //     shop_id: '101',
        //     log_type: '2',
        //     event_category: 'click',
        //     event_name: 'btn_click',
        //     referer: window.history.state.back
        //   },
        //   {
        //     btn_id: 'PRO-' + id,
        //     btn_name: menuName + '',
        //     menu_name: menuName + '',
        //     menu_id: id + '',
        //     system_code: 'PRO',
        //     system_name: 'Portal统一登录系统',
        //     uname: userName,
        //     uid: userId,
        //     time: new Date()
        //   }
        // )
      }
    })

    return {
      isEnglish: isEnglish.value,
      overColor: '#a7a7a7',
      ...toRefs(state)
    }
  },
  methods: {
    async handleFavorite(e, item) {
      e.stopPropagation()
      try {
        if (item.favorite === 0) {
          const res = await add_favorite_menu({ menuId: item.id })
          if (res.success) {
            message.success({ key: 'favorite', content: '收藏成功' })
            store.commit('user/updateFavoriteMenus', { ...item, favorite: 1 })
            item.favorite = 1
          } else {
            message.error({ key: 'favorite', content: '收藏失败' })
          }
        } else {
          const res = await remove_favorite_menu({ menuId: item.id })
          if (res.success) {
            message.success({ key: 'unfavorite', content: '取消收藏成功' })
            store.commit('user/updateFavoriteMenus', { ...item, favorite: 0 })
            item.favorite = 0
          } else {
            message.error({ key: 'unfavorite', content: '取消收藏失败' })
          }
        }
      } catch (error) {
        message.error({ key: 'favorite', content: '收藏失败' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.menuIcon {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
  margin-top: -5px;
}

.favorite-icon {
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 12px;
  height: 20px;
  width: 20px;

  .anticon {
    font-size: 16px;
  }
}

.portal-ant-menu-title-content:hover {
  .favorite-icon {
    display: flex;
  }
}
</style>
<style lang="scss">
.portal-ant-layout-sider-collapsed .portal-ant-menu-submenu-title,
.portal-ant-layout-sider-collapsed
  .portal-ant-menu-submenu
  > .portal-ant-menu-submenu-title,
.portal-ant-layout-sider-collapsed .portal-ant-menu-item {
  padding-left: 8px !important;
  padding-right: 8px !important;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  overflow: hidden;
}
.sidebar-item {
  .portal-ant-menu-title-content {
    max-width: 96% !important;
  }
}
</style>
